// extracted by mini-css-extract-plugin
module.exports = {"signUp":"sXvZz"};